/* unplugin-vue-components disabled */import { render } from "./OfferRefDemandDialog.vue?vue&type=template&id=b7e7eebc&scoped=true"
import script from "./OfferRefDemandDialog.vue?vue&type=script&lang=js"
export * from "./OfferRefDemandDialog.vue?vue&type=script&lang=js"

import "./OfferRefDemandDialog.vue?vue&type=style&index=0&id=b7e7eebc&lang=scss&scoped=true"

import exportComponent from "/Users/shinone/workingspace/xw/xwtec-assets-client/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.24_vue@3.5.24_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7e7eebc"]])

export default __exports__